import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import SequencesView from '@/components/sequences/sequences-view'
import { loadCrmPageProps } from '@/lib/crm-page'

const SequencesPage: FC<Partial<CrmPageProps>> = ({ data, today }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Email sequences" description="Outreach sequences your team works through.">
            <PageHeader title="Email Sequences" />
            <SequencesView />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<CrmPageProps> = async () => {
    return { props: await loadCrmPageProps() }
}

export default SequencesPage
